export const percentToFraction = (target: number | null | undefined): number | undefined => {
    if (target === null || target === undefined) {
        return undefined;
    }
    return (target * 100) / 10000;
};
